import { render, staticRenderFns } from "./buyAgentCard.vue?vue&type=template&id=5edb43bc&scoped=true&"
import script from "./buyAgentCard.vue?vue&type=script&lang=js&"
export * from "./buyAgentCard.vue?vue&type=script&lang=js&"
import style0 from "./buyAgentCard.vue?vue&type=style&index=0&id=5edb43bc&lang=less&scoped=true&"
import style1 from "./buyAgentCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb43bc",
  null
  
)

export default component.exports